export const ACTMembershipFormConstants = {
	aboriginalDescent: "AboriginalDescent",
	declareContactShared: "DeclareContactShared",
	address1: "Address1",
	address2: "Address2",
	membershipFee: "MembershipFee",
	declareJoinAlp: "DeclareJoinAlp",
	declarePayAlp: "DeclarePayAlp",
	CALD: "CALD",
	category: "Category",
	dateOfBirth: "DateOfBirth",
	declareNotPoliticalMember: "DeclareNotPoliticalMember",
	disability: "Disability",
	hasDisability: "hasDisability",
	email: "Email",
	ethnicity: "Ethnicity",
	firstName: "FirstName",
	gender: "Gender",
	phoneHome: "PhoneHome",
	lastName: "LastName",
	LBGTIQ: "LBGTIQ",
	mobile: "Mobile",
	occupation: "Occupation",
	paymentInterval: "PaymentInterval",
	postal1: "Postal1",
	postal2: "Postal2",
	postalCode: "PostalCode",
	postalState: "PostalState",
	postalSuburb: "PostalSuburb",
	postcode: "Postcode",
	preferredFirstName: "PreferredFirstName",
	previousMembershipNumber: "PreviousMembershipNumber",
	primaryLanguage: "PrimaryLanguage",
	sameAsResidential: "SameAsResidential",
	state: "State",
	suburb: "Suburb",
	title: "Title",
	transferring: "Transferring",
	transferringFrom: "TransferringFrom",
	isUnionMember: "IsUnionMember",
	unionMemberOf: "UnionMemberOf",
	phoneBusiness: "PhoneBusiness",
};

export interface IACTMembershipFormModel {
	firstName: string;
	lastName: string;
	preferredFirstName: string;
	title: string;
	dateOfBirth: string;
	email: string;
	mobile: string;
	phoneHome: string;
	phoneBusiness: string;
	address1: string;
	address2: string;
	suburb: string;
	state: string;
	postcode: string;
	sameAsResidential: string;
	postal1: string;
	postal2: string;
	postalSuburb: string;
	postalState: string;
	postalCode: string;
	gender: string;
	aboriginalDescent: string;
	CALD: string;
	LBGTIQ: string;
	ethnicity: string;
	primaryLanguage: string;
	disability: string;
	hasDisability: string;
	transferring: string;
	transferringFrom: string;
	previousMembershipNumber: string;
	category: string;
	occupation: string;
	isUnionMember: string;
	unionMemberOf: string;
	declareContactShared: string;
	declareNotPoliticalMember: string;
	declareJoinAlp: string;
	declarePayAlp: string;
	membershipFee: number;
	paymentInterval: string;
}

export const ACTMembershipInitialValues = {
	[ACTMembershipFormConstants.firstName]: "",
	[ACTMembershipFormConstants.lastName]: "",
	[ACTMembershipFormConstants.preferredFirstName]: "",
	[ACTMembershipFormConstants.title]: "",
	[ACTMembershipFormConstants.dateOfBirth]: "",
	[ACTMembershipFormConstants.email]: "",
	[ACTMembershipFormConstants.mobile]: "",
	[ACTMembershipFormConstants.phoneHome]: "",
	[ACTMembershipFormConstants.phoneBusiness]: "",
	[ACTMembershipFormConstants.address1]: "",
	[ACTMembershipFormConstants.address2]: "",
	[ACTMembershipFormConstants.suburb]: "",
	[ACTMembershipFormConstants.state]: "ACT",
	[ACTMembershipFormConstants.postcode]: "",
	[ACTMembershipFormConstants.sameAsResidential]: "",
	[ACTMembershipFormConstants.postal1]: "",
	[ACTMembershipFormConstants.postal2]: "",
	[ACTMembershipFormConstants.postalSuburb]: "",
	[ACTMembershipFormConstants.postalState]: "",
	[ACTMembershipFormConstants.postalCode]: "",
	[ACTMembershipFormConstants.gender]: "",
	[ACTMembershipFormConstants.aboriginalDescent]: "",
	[ACTMembershipFormConstants.CALD]: "",
	[ACTMembershipFormConstants.LBGTIQ]: "",
	[ACTMembershipFormConstants.ethnicity]: "",
	[ACTMembershipFormConstants.primaryLanguage]: "",
	[ACTMembershipFormConstants.disability]: "",
	[ACTMembershipFormConstants.hasDisability]: "",
	[ACTMembershipFormConstants.transferring]: "",
	[ACTMembershipFormConstants.transferringFrom]: "",
	[ACTMembershipFormConstants.previousMembershipNumber]: "",
	[ACTMembershipFormConstants.category]: "",
	[ACTMembershipFormConstants.occupation]: "",
	[ACTMembershipFormConstants.isUnionMember]: "",
	[ACTMembershipFormConstants.unionMemberOf]: "",
	[ACTMembershipFormConstants.declareContactShared]: "",
	[ACTMembershipFormConstants.declareNotPoliticalMember]: "",
	[ACTMembershipFormConstants.declareJoinAlp]: "",
	[ACTMembershipFormConstants.declarePayAlp]: "",
	[ACTMembershipFormConstants.membershipFee]: 0,
	[ACTMembershipFormConstants.paymentInterval]: "",
};

export const Languages = [
	"",
	"Aboriginal English, so described",
	"Acehnese",
	"Acholi",
	"Adnymathanha",
	"African Languages, nec",
	"Afrikaans",
	"Akan",
	"Alawa",
	"Albanian",
	"Alngith",
	"Alyawarr",
	"American Languages",
	"Amharic",
	"Amurdak",
	"Anindilyakwa",
	"Anmatyerr, nec",
	"Antekerrepenh",
	"Antikarinya",
	"Anuak",
	"Arabana",
	"Arabic",
	"Arandic, nec",
	"Armenian",
	"Arnhem Land and Daly River Region Languages, nec",
	"Aromunian (Macedo-Romanian)",
	"Arrernte, nec",
	"Assamese",
	"Assyrian Neo-Aramaic",
	"Auslan",
	"Azeri",
	"Baanbay",
	"Badimaya",
	"Balinese",
	"Balochi",
	"Bandjalang",
	"Banyjima",
	"Barababaraba",
	"Bardi",
	"Bari",
	"Basque",
	"Bassa",
	"Batjala",
	"Belorussian",
	"Bemba",
	"Bengali",
	"Bidjara",
	"Bikol",
	"Bilinarra",
	"Bisaya",
	"Bislama",
	"Bosnian",
	"Bulgarian",
	"Bunuba",
	"Burarra",
	"Burarran, nec",
	"Burmese",
	"Burmese and Related Languages, nec",
	"Cantonese",
	"Cape York Peninsula Languages, nec",
	"Catalan",
	"Cebuano",
	"Celtic, nec",
	"Central Anmatyerr",
	"Chaldean Neo-Aramaic",
	"Chin Haka",
	"Chinese, nec",
	"Croatian",
	"Czech",
	"Czechoslovakian, so described",
	"Daatiwuy",
	"Dadi Dadi",
	"Dalabon",
	"Dan (Gio-Dan)",
	"Danish",
	"Dari",
	"Dhalwangu",
	"Dhanggatti",
	"Dhangu, nec",
	"Dharawal",
	"Dhay'yi, nec",
	"Dhivehi",
	"Dhuwal, nec",
	"Dhuwala, nec",
	"Dhuwaya",
	"Dinka",
	"Diyari",
	"Djabugay",
	"Djabwurrung",
	"Djambarrpuyngu",
	"Djangu",
	"Djapu",
	"Djarrwark",
	"Djinang, nec",
	"Djinba",
	"Djinba, nec",
	"Dravidian, nec",
	"Dutch",
	"Dyirbal",
	"Eastern Anmatyerr",
	"Eastern Arrernte",
	"English",
	"Estonian",
	"Ewe",
	"Fijian",
	"Fijian Hindustani",
	"Filipino",
	"Finnish",
	"Finnish and Related Languages, nec",
	"French",
	"Frisian",
	"Fulfulde",
	"Ga",
	"Gaelic (Scotland)",
	"Galpu",
	"Gambera",
	"Gamilaraay",
	"Ganalbingu",
	"Garrwa",
	"Garuwali",
	"Georgian",
	"German",
	"Gilbertese",
	"Girramay",
	"Githabul",
	"Golumala",
	"Gooniyandi",
	"Greek",
	"Gudanji",
	"Gudjal",
	"Gujarati",
	"Gumatj",
	"Gumbaynggir",
	"Gundjeihmi",
	"Gun-nartpa",
	"Gupapuyngu",
	"Gurindji",
	"Gurindji Kriol",
	"Gurr-goni",
	"Guugu Yimidhirr",
	"Guyamirrilili",
	"Hakka",
	"Harari",
	"Hausa",
	"Hawaiian English",
	"Hazaraghi",
	"Hebrew",
	"Hindi",
	"Hmong",
	"Hmong-Mien, nec",
	"Hungarian",
	"Iban",
	"Iberian Romance, nec",
	"Icelandic",
	"Igbo",
	"IIokano",
	"Ilonggo (Hiligaynon)",
	"Indo-Aryan, nec",
	"Indonesian",
	"Invented Languages",
	"Iranic, nec",
	"Irish",
	"Italian",
	"Iwaidja",
	"Jaminjung",
	"Japanese",
	"Jaru",
	"Javanese",
	"Jawi",
	"Jawoyn",
	"Jingulu",
	"Kalaw Kawaw Ya/Kalaw Lagaw Ya",
	"Kanai",
	"Kannada",
	"Karajarri",
	"Karen",
	"Kariyarra",
	"Kartujarra",
	"Kashmiri",
	"Kaurna",
	"Kayardild",
	"Kaytetye",
	"Keerray-Woorroong",
	"Key Word Sign Australia",
	"Khmer",
	"Kija",
	"Kikuyu",
	"Kimberley Area Languages, nec",
	"Kinyarwanda (Rwanda)",
	"Kirundi (Rundi)",
	"Kiwai",
	"Koko-Bera",
	"Konkani",
	"Korean",
	"Kpelle",
	"Krahn",
	"Krio",
	"Kriol",
	"Kugu Muminh",
	"Kukatha",
	"Kukatja",
	"Kuku Yalanji",
	"Kunbarlang",
	"Kune",
	"Kuninjku",
	"Kunwinjku",
	"Kunwinjkuan, nec",
	"Kurdish",
	"Kuuk Thayorre",
	"Kuuku-Ya'u",
	"Kuwema",
	"Ladji Ladji",
	"Lamalama",
	"Lao",
	"Lardil",
	"Larrakiya",
	"Latin",
	"Latvian",
	"Letzeburgish",
	"Liberian (Liberian English)",
	"Light Warlpiri",
	"Lingala",
	"Lithuanian",
	"Liyagalawumirr",
	"Liyagawumirr",
	"Loma (Lorma)",
	"Luganda",
	"Lumun (Kuku Lumun)",
	"Luo",
	"Luritja",
	"Macedonian",
	"Madarrpa",
	"Madi",
	"Malak Malak",
	"Malay",
	"Malayalam",
	"Malngin",
	"Maltese",
	"Mandaean (Mandaic)",
	"Mandarin",
	"Mandinka",
	"Mangala",
	"Mangarrayi",
	"Manggalili",
	"Mann",
	"Manyjalpingu",
	"Manyjilyjarra",
	"Maori (Cook Island)",
	"Maori (New Zealand)",
	"Marathi",
	"Maringarr",
	"Marra",
	"Marramaninyshi",
	"Marrangu",
	"Marridan (Maridan)",
	"Marrithiyel",
	"Martu Wangka",
	"Matngala",
	"Maung",
	"Mauritian Creole",
	"Mayali",
	"Meriam Mir",
	"Middle Eastern Semitic Languages, nec",
	"Min Nan",
	"Miriwoong",
	"Mirning",
	"Mon",
	"Mongolian",
	"Mon-Khmer, nec",
	"Moro (Nuba Moro)",
	"Morrobalama",
	"Motu (HiriMotu)",
	"Mudburra",
	"Murrinh Patha",
	"Muruwari",
	"Na-kara",
	"Narungga",
	"Nauruan",
	"Ndebele",
	"Ndjebbana (Gunavidji)",
	"Nepali",
	"Ngaanyatjarra",
	"Ngalakgan",
	"Ngaliwurru",
	"Ngandi",
	"Ngan'gikurunggurr",
	"Ngardi",
	"Ngarinyin",
	"Ngarinyman",
	"Ngarluma",
	"Ngarrindjeri",
	"Ngatjumaya",
	"Nhangu",
	"Nhangu, nec",
	"Niue",
	"Norf'k-Pitcairn",
	"Northern Desert Fringe Area Languages, nec",
	"Norwegian",
	"Nuer",
	"Nungali",
	"Nunggubuyu",
	"Nyamal",
	"Nyangumarta",
	"Nyanja (Chichewa)",
	"Nyikina",
	"Nyungar",
	"Oceanian Pidgins and Creoles, nec",
	"Oriya",
	"Oromo",
	"Other Australian Indigenous Languages, nec",
	"Other Eastern Asian Languages, nec",
	"Other Eastern European Languages, nec",
	"Other Southeast Asian Languages",
	"Other Southern Asian Languages",
	"Other Southern European Languages, nec",
	"Other Southwest and Central Asian Languages, nec",
	"Other Yolngu Matha, nec",
	"Paakantyi",
	"Pacific Austronesian Languages, nec",
	"Palyku/Nyiyaparli",
	"Pampangan",
	"Papua New Guinea Languages, nec",
	"Pashto",
	"Persian (excluding Dari)",
	"Pintupi",
	"Pitjantjatjara",
	"Polish",
	"Portuguese",
	"Punjabi",
	"Rembarrnga",
	"Rirratjingu",
	"Ritharrngu",
	"Rohingya",
	"Romanian",
	"Romany",
	"Rotuman",
	"Russian",
	"Samoan",
	"Scandinavian, nec",
	"Serbian",
	"Serbo-Croatian/Yugoslavian, so described",
	"Seychelles Creole",
	"Shilluk",
	"Shona",
	"Sign Languages, nec",
	"Sindhi",
	"Sinhalese",
	"Slovak",
	"Slovene",
	"Solomon Islands Pijin",
	"Somali",
	"Southeast Asian Austronesian Languages, nec",
	"Spanish",
	"Swahili",
	"Swedish",
	"Tagalog",
	"Tai, nec",
	"Tamil",
	"Tatar",
	"Telugu",
	"Tetum",
	"Thai",
	"Thaynakwith",
	"Themne",
	"Tibetan",
	"Tigre",
	"Tigrinya",
	"Timorese",
	"Tiwi",
	"Tjungundji",
	"Tjupany",
	"Tok Pisin (Neomelanesian)",
	"Tokelauan",
	"Tongan",
	"Tswana",
	"Tulu",
	"Turkic, nec",
	"Turkish",
	"Turkmen",
	"Tuvaluan",
	"Ukrainian",
	"Urdu",
	"Uygur",
	"Uzbek",
	"Vietnamese",
	"Waanyi",
	"Wagilak",
	"Wagiman",
	"Wajarri",
	"Walmajarri",
	"Waluwarra",
	"Wambaya",
	"Wangkajunga",
	"Wangkangurru",
	"Wangkatha",
	"Wangurri",
	"Wanyjirra",
	"Wardaman",
	"Wargamay",
	"Warlmanpa",
	"Warlpiri",
	"Warnman",
	"Warramiri",
	"Warumungu",
	"Welsh",
	"Wergaia",
	"Western Arrarnta",
	"Western Desert Languages, nec",
	"Wik Mungkan",
	"Wik Ngathan",
	"Wiradjuri",
	"Worla",
	"Worrorra",
	"Wu",
	"Wubulkarra",
	"Wunambal",
	"Wurlaki",
	"Xhosa",
	"Yakuy, nec",
	"Yankunytjatjara",
	"Yan-nhangu",
	"Yanyuwa",
	"Yapese",
	"Yawuru",
	"Yiddish",
	"Yidiny",
	"Yindjibarndi",
	"Yinhawangka",
	"Yorta Yorta",
	"Yoruba",
	"Yugambeh",
	"Yulparija",
	"Yumplatok (Torres Strait Creole)",
	"Yupangathi",
	"Zomi",
	"Zulu",
];

export const Ethnicities = [
	"",
	"Acehnese",
	"Acholi",
	"Afghan",
	"African American",
	"Afrikaner",
	"Akan",
	"Albanian",
	"Algerian",
	"American",
	"Amhara",
	"Anglo-Burmese",
	"Anglo-Indian",
	"Angolan",
	"Arab, nec",
	"Argentinian",
	"Armenian",
	"Assyrian",
	"Australian",
	"Australian Aboriginal",
	"Australian South Sea Islander",
	"Austrian",
	"Azeri",
	"Bahraini",
	"Balinese",
	"Bangladeshi",
	"Barbadian",
	"Bari",
	"Basque",
	"Batswana",
	"Belarusan",
	"Belgian",
	"Bengali",
	"Berber",
	"Bermudan",
	"Bhutanese",
	"Bolivian",
	"Bosnian",
	"Brazilian",
	"British, nec",
	"Bruneian",
	"Bulgarian",
	"Burgher",
	"Burmese",
	"Burundian",
	"Cameroonian",
	"Canadian",
	"Caribbean Islander, nec",
	"Catalan",
	"Central American, nec",
	"Central and West African, nec",
	"Central Asian, nec",
	"Chaldean",
	"Channel Islander",
	"Chilean",
	"Chin",
	"Chinese",
	"Chinese Asian, nec",
	"Colombian",
	"Congolese",
	"Cook Islander",
	"Coptic",
	"Costa Rican",
	"Croatian",
	"Cuban",
	"Cypriot",
	"Czech",
	"Danish",
	"Darfur",
	"Dinka ",
	"Dutch",
	"Eastern European, nec",
	"Ecuadorian",
	"Egyptian",
	"Emirati",
	"English",
	"Eritrean",
	"Estonian",
	"Ethiopian",
	"Fijian",
	"Fijian Indian ",
	"Filipino",
	"Finnish",
	"Flemish",
	"French",
	"French Canadian",
	"Frisian",
	"Fulani",
	"Georgian",
	"German",
	"Ghanaian",
	"Gibraltarian",
	"Gio",
	"Greek",
	"Guatemalan",
	"Gujarati",
	"Guyanese",
	"Hawaiian",
	"Hazara",
	"Hispanic North American",
	"Hmong",

	"Hungarian",
	"Hutu",
	"Icelandic",
	"Igbo",
	"I-Kiribati",
	"Indian",
	"Indian Tamil ",
	"Indonesian",
	"Iranian",
	"Iraqi",
	"Irish",
	"Italian",
	"Ivorean",
	"Jamaican",
	"Japanese",
	"Javanese",
	"Jewish",
	"Jordanian",
	"Kadazan",
	"Karen",
	"Kashmiri",
	"Kazakh",
	"Kenyan",
	"Khmer (Cambodian)",
	"Korean",
	"Krahn",
	"Kunama",
	"Kurdish",
	"Kuwaiti",
	"Kyrgyz",
	"Lao",
	"Latvian",
	"Lebanese",
	"Liberian",
	"Libyan",
	"Lithuanian",
	"Luxembourg",
	"Macedonian",
	"Madi",
	"Madurese",
	"Mainland South-East Asian, nec",
	"Malawian",
	"Malay",
	"Malayali",
	"Maldivian",
	"Maltese",
	"Mandaean",
	"Mandinka",
	"Manx",
	"Maori",
	"Maritime South-East Asian, nec",
	"Masai",
	"Mauritian",
	"Mayan",
	"Melanesian and Papuan, nec",
	"Mexican",
	"Micronesian, nec",
	"Moldovan",
	"Mon",
	"Mongolian",
	"Montenegrin",
	"Moroccan",
	"Mozambican",
	"Namibian",
	"Native North American Indian",
	"Nauruan",
	"Nepalese",
	"New Caledonian",
	"New Zealander",
	"Nicaraguan",
	"Nigerian",
	"Niuean",
	"Ni-Vanuatu",
	"North American, nec",
	"Northern European, nec",
	"Norwegian",
	"Nubian ",
	"Nuer",
	"Ogaden",
	"Omani",
	"Oromo",
	"Other North African and Middle Eastern, nec",
	"Other North-East Asian, nec",
	"Pakistani",
	"Palestinian",
	"Papua New Guinean",
	"Paraguayan",
	"Parsi",
	"Pathan",
	"Peoples of the Sudan, nec",
	"Peruvian",
	"Pitcairn",
	"Polish",
	"Polynesian, nec",
	"Portuguese",
	"Puerto Rican",
	"Punjabi",
	"Qatari",
	"Rohingya",
	"Roma Gypsy",

	"Romanian",
	"Russian",
	"Rwandan",
	"Salvadoran",
	"Samoan",
	"Saudi Arabian",
	"Scottish",
	"Senegalese",
	"Serbian",
	"Seychellois",
	"Shona",
	"Sierra Leonean",
	"Sikh",
	"Sindhi",
	"Singaporean",
	"Sinhalese",
	"Slovak",
	"Slovene",
	"Solomon Islander",
	"Somali",
	"Sorb/Wend",
	"South African",
	"South American, nec",
	"South Eastern European, nec",
	"South Sudanese",
	"Southern and East African, nec",
	"Southern Asian, nec",
	"Southern European, nec",
	"Spanish",
	"Sri Lankan",
	"Sri Lankan Tamil",
	"Sudanese",
	"Sundanese",
	"Swahili",
	"Swazilander",
	"Swedish",
	"Swiss",
	"Syrian",
	"Tahitian",
	"Taiwanese",
	"Tajik",
	"Tamil, nfd",
	"Tanzanian",
	"Tatar",
	"Telugu",
	"Temoq",
	"Thai",
	"Themne",
	"Tibetan",
	"Tigrayan",
	"Tigre",
	"Timorese",
	"Togolese",
	"Tokelauan",
	"Tongan",
	"Torres Strait Islander",
	"Trinidadian Tobagonian",
	"Tunisian",
	"Turkish",
	"Turkmen",
	"Tuvaluan",
	"Ugandan",
	"Uighur",
	"Ukrainian",
	"Uruguayan",
	"Uzbek",
	"Venezuelan",
	"Vietnamese",
	"Vlach",
	"Welsh",
	"Western European, nec",
	"Yemeni",
	"Yezidi",
	"Yoruba",
	"Zambian",
	"Zimbabwean",
	"Zulu",
];
